/** Date et heure françaises séparées (ex. cartes annonces). */
export function splitFrenchDateTime(iso: string | null | undefined): { date: string; time: string } | null {
  if (!iso?.trim()) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return {
    date: d.toLocaleDateString('fr-FR'),
    time: d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
  };
}

/** Affichage inline « 19/06/2026 · 15:48 » */
export function formatFrenchDateTimeInline(iso: string | null | undefined): string {
  const parts = splitFrenchDateTime(iso);
  return parts ? `${parts.date} · ${parts.time}` : '—';
}

/** Date seule « 03/06/2026 » (ex. date de trouvaille). */
export function formatFrenchDateOnly(iso: string | null | undefined): string {
  const parts = splitFrenchDateTime(iso);
  return parts?.date ?? '—';
}

/** Date + heure « 03/06/2026 à 10:03 » (ex. après « Créé le »). */
export function formatFrenchDateAtTime(iso: string | null | undefined): string {
  const parts = splitFrenchDateTime(iso);
  return parts ? `${parts.date} à ${parts.time}` : '—';
}
